ThemeJS.Global = (function ( $ ) {
    jQuery(document).ready(function( $ ){
    
        $(".fade-in").addClass("beige-underline-300");
    
        $('.first-button').on('click', function () {
            $('.animated-icon1').toggleClass('open');
        }); 

        $.each($('.lift-stories-description-container'), function(i, val){
            var text = $(this).children().text();
            if(text.length > 75){
                text = text.substr(0, 75) + '...';
                $(this).html("<p>" + text + "</p>");
            }else{
                $(this).html("<p>" + text + "</p>");
            }
            
        });
    });
    
})();